<template>
  <el-select
    v-model="objectModel"
    @change="objectChanged"
    autocomplete="new-password"
    :placeholder="placeholder"
    :filterable="true"
    :multiple="false"
    :disabled="disabled"
    remote
    :remote-method="getObjects"
    :loading="loading"
  >
    <el-option :value="null" :label="$t('COMMON.NONE')"> </el-option>
    <el-option
      v-for="object in objects"
      :key="object.id"
      :value="object.id"
      :label="`${object[objectSearchField]}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { camelCase, snakeCase } from "lodash";
import { Option, Select } from "element-ui";

export default {
  name: "object-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    object: {
      type: String,
      description: "Object id",
    },
    objectType: {
      type: String,
      required: true,
      description: "Object type",
    },
    objectSearchField: {
      type: String,
      required: true,
      description: "Key of the name of the object",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
  },

  data() {
    return {
      objectModel: this.object,
      objects: {},
    };
  },

  setup() {},

  computed: {
    placeholder() {
      return this.$t(`COMMON.${snakeCase(this.objectType).toUpperCase()}`);
    },
  },

  created() {
    this.getObjects(null, this.object);
  },

  methods: {
    async getObjects(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: this.objectSearchField,
          filter: {
            ...(query ? { search: query } : {}),
            ...(id ? { with_ids: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        await this.$store.dispatch(
          `${camelCase(this.objectType)}/list`,
          params
        );
        const objectsArr = await this.$store.getters[
          `${camelCase(this.objectType)}/list`
        ];
        this.objects = {};
        objectsArr.forEach((object) => {
          this.objects[object.id] = object;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    objectChanged(object) {
      this.$emit("objectChanged", object);
    },
  },

  watch: {
    object(object) {
      if (object) {
        this.objectModel = object;
        if (object !== this.objectModel) {
          this.getObjects(null, object);
        }
      } else {
        this.objectModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getObjects();
    },
  },
};
</script>
